<template>
  <div class="main">
    <img src="@/assets/image/login/login-bg.png" alt="" class="login-background"/>
    <div class="card" v-if="!showSplash">
      <div class="form">
        <div class="form-bg">
          <img class="img" src="@/assets/image/login/login-bg-icon-2.png" alt=""/>
        </div>
        <div class="form-data">
          <div class="form-title-container">
            <div class="logo-container-p">
              <div class="logo-wrapper">
                <!-- 外层光环 -->
                <div class="logo-ring"></div>
                <!-- 内层发光环 -->
                <div class="logo-inner-ring"></div>
                <!-- Logo核心容器 -->
                <div class="logo-container">
                  <slot name="logo"/>
                  <!-- 发光效果层 -->
                  <div class="logo-glow"></div>
                </div>
                <!-- 粒子装饰 -->
                <div class="particles">
                  <span class="particle p1"></span>
                  <span class="particle p2"></span>
                  <span class="particle p3"></span>
                  <span class="particle p4"></span>
                  <span class="particle p5"></span>
                  <span class="particle p6"></span>
                </div>
              </div>
            </div>

            <div class="form-title">
              <slot name="title">{{systemTitle}}</slot>
            </div>
          </div>
          <el-form
              class="login-form"
              ref="ruleForm"
              :model="userDto"
              label-width="0"
              label-position="top"
              :rules="rules"
          >
            <el-form-item prop="account">
              <el-input class="no-colon"
                  v-model="userDto.account"
                  placeholder="账号"
                  clearable
              >
                <template #prefix>
                  <yq-icon name="element-ui_user"/>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input class="no-colon"
                  v-model="userDto.password"
                  placeholder="密码"
                  clearable
                  show-password
                  @keydown.enter.native="submitForm('ruleForm')"
              >
                <template #prefix>
                  <yq-icon name="element-ui_lock"/>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="check-number-container">
                <el-input class="check-number no-colon"
                          v-model="userDto.checkNumber"
                          placeholder="验证码"
                          clearable @keydown.enter.native="submitForm('ruleForm')"
                >
                  <template #prefix>
                    <yq-icon name="erweima"/>
                  </template>
                </el-input>
                <img alt="" class="check-number" :src="`data:image/png;base64,${aesCheckCode.dictName}`"/>
              </div>
              <yq-icon name="element-ui_refresh" class="check-number-refresh" @click="getCheckCode"/>
            </el-form-item>
            <el-form-item>
              <slot name="login-button">
                <el-button class="login-button" @click="submitForm('ruleForm')">
                  <span class="btn-text">登 录</span>
                  <span class="btn-glow"></span>
                </el-button>
              </slot>
            </el-form-item>
              <el-form-item v-if="qywxEnable">
                <div class="third-login" v-if="type === 'merchant'">
                  <div class="hr-line">
                    <div class="hr-content">第三方登录</div>
                  </div>
                  <table-button>企业微信登录</table-button>
                </div>
              </el-form-item>
          </el-form>
          <div class="copy-right">© 2026 管理系统 版权所有</div>
        </div>

      </div>
    </div>
<!--    <p class="deepInfo">© 四川小圆创科软件有限公司 2021-{{ new Date().format("yyyy") }} 版权所有 蜀ICP备2021030404号-3</p>-->
    <!-- 添加开屏动画组件 -->
    <div class="splash-screen" v-if="showSplash">
      <div class="splash-content">
        <div class="logo-container">
          <el-avatar :size="100" v-if="userDto.iconUrl" :src="userDto.iconUrl" class="logo"/>
          <yq-icon v-else name="user1" class="logo icon"/>
          <div class="logo-ring"></div>
        </div>
        <div class="loading-bar-container">
          <div class="loading-bar">
            <div class="progress" :style="{ width: progress + '%' }">
              <div class="progress-glow"></div>
            </div>
          </div>
          <div class="progress-text">{{ progress }}%</div>
        </div>
        <div class="welcome-text">
          <span class="greeting">欢迎回来</span>
          <span class="name">{{ userDto.employeeName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from "@/api/baseApi";
import util from "@/util/util";
import { useRouter } from 'vue-router'
import AesUtil from "@/util/aesUtil";
import YqIcon from "@/components/YqIcon.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ImageUtil from "@/util/imageUtil";
export default {
  components: {TableButton, YqIcon},
  setup() {
    const router = useRouter()
    return {router}
  },
  // 在路由跳转之前，进行操作
  beforeRouteLeave(to, from, next) {
    next();
  },
  props: {
    type: {
      default: "merchant"
    },
    systemTitle: {default: "路桥交通工程公司安全管理平台"},
    backgroundImage: {default: ""},
    autoLogin: {default: false}, // 自动登录
    loginName: {default: ""},
    loginPassword: {default: ""},
    loginFunction: {default: null},
  },
  data() {
    return {
      userInfo: {},
      system: {
        code: "",
        name: ""
      },
      userDto: {
        account: "",
        password: "",
        checkNumber: "",
        employeeName: "",
        iconUrl: "",
      },
      rules: {
        account: [
          {required: true, trigger: "blur", message: "请输入你的账号"}
        ],
        password: [
          {required: true, trigger: "blur", message: "请输入你的密码"}
        ],
      },
      aesCheckCode: {},
      showSplash: false,
      progress: 0,
      progressTimer: null,
      qywxEnable: false,
    };
  },
  created() {
    this.qywxEnable = process.env.VUE_APP_QYWX_LOGIN === "true"; // 是否启用企业微信登录
    util.clearCacheData();
    util.clearSession();
    if (this.autoLogin) {
      // 自动登录
      this.showSplash = true;
      baseApi.getCheckNumber2().then(res => {
        this.aesCheckCode = res
        this.userDto.checkNumber = "";
        // 如果有参数
        let name = this.$route.query.name, pwd = this.$route.query.pwd;
        if (name && pwd) {
          this.userDto.account = name;
          this.userDto.password = pwd;
        } else {
          this.userDto.account = this.loginName;
          this.userDto.password = this.loginPassword;
        }
        this.login2(baseApi.loginEmployeeByPassword);
      });
    }
  },
  mounted() {
    setTimeout(() => {
      // 获取验证码
      this.getCheckCode();
    }, 1000)
  },
  methods: {
    // 获取验证码
    getCheckCode() {
      baseApi.getCheckNumber2().then(res => {
        this.aesCheckCode = res
        this.userDto.checkNumber = "";
      });
    },
    /** 登录 */
    submitForm(formName) {
      this.$refs[formName].validate(() => {
        if (this.loginFunction) {
          this.loginFunction({
            ...this.userDto,
            password: AesUtil.encode(this.aesCheckCode.dictCode, this.userDto.password),// 密码加密
            checkCode: this.aesCheckCode.dictCode, // iv
          }, this.userDto.password); // 第二个参数是明文密码，供登录页保存自动登录凭据，不会提交给后台
        } else {
          this.login2(baseApi.loginEmployeeByPassword);
        }
      });
    },
    // 获取登录表单的数据
    getFormData() {
      return this.userDto;
    },
    // 登录
    login2(loginFunc) {
      let data = {
        ...this.userDto,
        password: AesUtil.encode(this.aesCheckCode.dictCode, this.userDto.password),// 密码加密
        checkCode: this.aesCheckCode.dictCode, // iv
      }
      // 跳转到商户页面
      loginFunc(data).then(account => {
        // 登录成功，跳转
        this.loginSuccess(account);
      }).catch(() => {
        this.getCheckCode();
      });
    },
    // 登录成功，跳转页面
    loginSuccess(account) {
      util.clearCacheData();// 清空缓存,
      // 更改头像链接
      account.iconUrl = ImageUtil.getFileUrlSingle(account.iconUrl);
      util.setUserInfo(account); // 设置登录信息
      // 设置职员名称
      this.userDto.employeeName = account.employeeName;
      // 头像
      this.userDto.iconUrl = account.iconUrl;
      this.userInfo = account;
      // 显示开屏动画
      this.startProgress();
      setTimeout(() => {
        this.router.push({path: "/"});
      }, 2000);
    },
    startProgress() {
      this.showSplash = true;
      let progress = 0;
      this.progressTimer = setInterval(() => {
        progress += 2;
        this.progress = progress;
        if (progress >= 100) {
          clearInterval(this.progressTimer);
        }
      }, 30); // 总时长约1.5秒
    }
  },
  beforeUnmount() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
    }
  }
}
</script>
<style lang="scss" scoped>

.main {
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  .login-background{
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 0;
  }
  p {
    width: 100%;
    align-items: center;

    img {
      width: 36px;
      margin-right: 12px;
    }

    span {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .card{
    flex: 1;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .form {
      width: 930px;
      //background: rgba(255,255,255,.8);
      padding: 30px 20px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .form-bg{
        width: 410px;
        .img{
          width: 100%;
          //opacity: .5;
        }
      }
      .form-data{
        width: 400px;
        background: #FFF;
        padding: 0 0 20px;
        border-radius: 4px;
        overflow: hidden;
        .form-title-container{
          background: linear-gradient(135deg, #93c5fd 0%, #60a5fa 50%, #3b82f6 100%);
          padding: 20px 0;
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.5) 0%, transparent 50%),
                        radial-gradient(circle at 70% 80%, rgba(191, 219, 254, 0.4) 0%, transparent 45%);
            pointer-events: none;
          }
          
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
            pointer-events: none;
          }
          .logo-container-p{
            display: flex;
            width: 100%;
            justify-content: center;
            //margin-bottom: 20px;
            .logo-wrapper {
              position: relative;
              width: 140px;
              height: 140px;
              margin: auto 20px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            /* 外层光环 - 旋转动画 */
            .logo-ring {
              position: absolute;
              width: 100%;
              height: 100%;
              border: 2px solid rgba(54, 209, 220, 0.3);
              border-radius: 50%;
              animation: ringRotate 15s linear infinite;

              &::before {
                content: "";
                position: absolute;
                top: -4px;
                left: 50%;
                width: 10px;
                height: 10px;
                background: #36d1dc;
                border-radius: 50%;
                box-shadow: 0 0 15px #36d1dc,
                0 0 30px rgba(54, 209, 220, 0.6),
                0 0 45px rgba(54, 209, 220, 0.4);
                transform: translateX(-50%);
              }
            }

            @keyframes ringRotate {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }

            /* 内层发光环 */
            .logo-inner-ring {
              position: absolute;
              width: 80%;
              height: 80%;
              border: 1px solid rgba(91, 134, 229, 0.4);
              border-radius: 50%;
              animation: innerRingRotate 10s linear infinite reverse;

              &::before {
                content: "";
                position: absolute;
                top: 50%;
                right: -2px;
                width: 6px;
                height: 6px;
                background: #5b86e5;
                border-radius: 50%;
                box-shadow: 0 0 10px #5b86e5,
                0 0 20px rgba(91, 134, 229, 0.6);
                transform: translateY(-50%);
              }
            }

            @keyframes innerRingRotate {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }

            /* Logo核心容器 */
            .logo-container {
              position: relative;
              width: 90px;
              height: 90px;
              border-radius: 50%;
              background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%);
              backdrop-filter: blur(10px);
              display: flex;
              justify-content: center;
              align-items: center;
              box-shadow: 0 8px 32px rgba(54, 209, 220, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);


              /* Logo发光效果 */
              .logo-glow {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 80%;
                height: 80%;
                background: radial-gradient(circle, rgba(54, 209, 220, 0.3) 0%, transparent 70%);
                border-radius: 50%;
                transform: translate(-50%, -50%);
                animation: glowPulse 3s ease-in-out infinite;
              }
              @keyframes glowPulse {
                0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(1); }
                50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.1); }
              }
            }
            /* 粒子装饰 */
            .particles {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              .particle {
                position: absolute;
                width: 4px;
                height: 4px;
                background: rgba(54, 209, 220, 0.7);
                border-radius: 50%;
                animation: particleFloat 4s ease-in-out infinite;

                &.p1 { top: 5%; left: 50%; animation-delay: 0s; }
                &.p2 { top: 25%; right: 8%; animation-delay: 0.6s; }
                &.p3 { bottom: 25%; right: 8%; animation-delay: 1.2s; }
                &.p4 { bottom: 5%; left: 50%; animation-delay: 1.8s; }
                &.p5 { bottom: 25%; left: 8%; animation-delay: 2.4s; }
                &.p6 { top: 25%; left: 8%; animation-delay: 3s; }
              }
              @keyframes particleFloat {
                0%, 100% {
                  transform: translateY(0) scale(1);
                  opacity: 0.3;
                }
                50% {
                  transform: translateY(-15px) scale(1.2);
                  opacity: 0.8;
                }
              }
            }
          }
        }
        .login-form{
          padding: 0 30px;
          box-sizing: border-box;
        }
        .form-title{
          color: #fff;
          font-size: 18px;
          font-weight: 800;
          text-align: center;
        }
        > * {
          width: 100%;
        }
        .el-form {
          margin-top: 30px;
          .el-input {
            font-size: 16px;
          }
          :deep( .el-form-item__label ) {
            padding: 0;
            font-size: 16px;
            font-weight: bold;
          }
          :deep( .el-form-item__label:before ) {
            display: none;
          }
          :deep( .el-input__inner) {
            border: 0;
            border-bottom: 1px solid #dcdfe6;
            border-radius: 0;
          }

          :deep( .el-input__prefix ) {
            left: 0;
          }
        }

        .btns {
          color: rgb(164, 164, 164);
          font-size: 14px;
          display: flex;
          justify-content: flex-end;
          //flex-direction: column;
          //align-items: flex-end;
          span {
            display: flex;
            align-items: center;
          }

          span:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }


        .el-button {
          width: 100%;
          border: 0;
        }
      }

    }
  }


  .deepInfo {
    font-size: 12px;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
    width: 100%;
  }

  .img {
    width: 37%;
  }
}

:deep( .el-dialog ) {
  margin-top: 10vh !important;
  width: 900px;
  height: 600px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    height: calc(100% - 60px);
    overflow-y: scroll;
    padding: 10px 20px;
  }

  .el-dialog__footer {
    text-align: center;
    padding: 0;

    .el-button-group {
      display: flex;
    }

    .el-button {
      width: 100%;
      border-radius: 0;
    }
  }
}

.redirect {
  position: absolute;
  top: -100px;
  right: 0;
  width: auto !important;
}

.third-login {
  text-align: center;
  width: 100%;

  .hr-line {
    border-top: 1px solid #dee0e2;
    height: 0;
    margin: 20px 0;

    .hr-content {
      padding: 0 10px;
      background: #f5f6f8;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      width: 80px;
      display: inline-block;
      position: absolute;
      top: 10px;
      left: calc(50% - 50px);
    }
  }

  .third-link {
    img {
      width: 20px;
      filter: grayscale(1);
      transition: all 1s;
    }

    img:hover {
      filter: grayscale(0);
    }
  }
}

:deep( .el-input__wrapper) {
  background: #e8f0fe;
  height: 40px;
  line-height: 40px;
  border-radius: 0;
  border: none;

  .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-bottom: none;
  }
}

:deep( .el-form-item__content) {
  display: flex;
  justify-content: space-between;
}

.check-number-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .check-number {
    width: 195px;
  }
}
.check-number-refresh{
  position: absolute;
  right: 0;
  bottom: 0;
  background: #CCC;
  color: #FFF;
  padding: 2px;
  line-height: 16px;
}
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.5s ease;
  background-repeat: no-repeat;
  background-size: cover;
  .splash-content {
    text-align: center;

    .logo-container {
      position: relative;
      margin-bottom: 40px;
      display: inline-block;
      color: #FFF;
      .logo {
        position: relative;
        z-index: 2;
        border: 3px solid #fff;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.8);
        animation: logoAppear 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
        &.icon{
          background: none;
          font-size: 55px;
          border: none;
          box-shadow: none;
        }
        :deep(img) {
          transition: transform 0.3s ease;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08),
          0 0 0 1px rgba(0, 0, 0, 0.08);

          :deep(img) {
            transform: scale(1.2);
          }
        }
      }

      .logo-ring {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90px;
        height: 90px;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.8);
        animation: ringPulse 2s ease-out infinite;
      }
    }

    .loading-bar-container {
      position: relative;
      margin: 30px auto;
      width: 240px;

      .loading-bar {
        height: 4px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        overflow: hidden;

        .progress {
          height: 100%;
          background: linear-gradient(90deg, #36d1dc, #5b86e5);
          border-radius: 4px;
          position: relative;
          transition: width 0.3s ease;

          .progress-glow {
            position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 100%;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
            animation: glowMove 2.5s linear infinite;
          }
        }
      }

      .progress-text {
        position: absolute;
        right: -40px;
        top: -8px;
        font-size: 14px;
        color: #FFF;
        font-weight: 500;
      }
    }

    .welcome-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
      opacity: 0;
      animation: fadeInUp 0.5s ease 0.3s forwards;

      .greeting {
        font-size: 16px;
        color: #FFF;
      }

      .name {
        font-size: 24px;
        color: #FFF;
        font-weight: 600;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes logoAppear {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes ringPulse {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
  }
}

@keyframes glowMove {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(1200%);
  }
}

@keyframes fadeInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.copy-right{
  text-align: center;
  color: var(--yq-font-color-desc);
  font-size: 12px;
  margin-top: 30px;
}
/* ============ 登录按钮样式 ============ */
.login-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  background: linear-gradient(135deg, #93c5fd 0%, #3b82f6 100%);
  border: none;
  color: #ffffff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(54, 209, 220, 0.4);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(54, 209, 220, 0.5);
  }

  &:active {
    transform: translateY(0);
  }

  .btn-text {
    position: relative;
    z-index: 2;
  }

  .btn-glow {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: btnShine 2s linear infinite;
  }

  @keyframes btnShine {
    100% { left: 100%; }
  }
}
:deep(.el-input){
  &.no-colon{
    .el-input__prefix-inner::after{
      content: "";
    }
  }
}
</style>